var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-list-group-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-add-staff",
      modifiers: {
        "modal-add-staff": true
      }
    }],
    staticClass: "d-flex align-items-center border-0",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('b-avatar', {
    staticClass: "mr-1",
    style: {
      opacity: _vm.disabled === true ? 0.2 : 1
    },
    attrs: {
      "variant": "primary"
    }
  }, [_c('svg', {
    staticClass: "bi bi-person-plus-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
    }
  })])]), _c('div', {
    staticClass: "mr-auto font-weight-bold text-nowrap"
  }, [_vm._v(" 加入成員 ")]), _c('b-modal', {
    attrs: {
      "id": "modal-add-staff",
      "title": "選擇員工",
      "ok-title": "確定",
      "cancel-title": "取消",
      "ok-disabled": !_vm.selectedStaff,
      "centered": ""
    },
    on: {
      "ok": function ok($event) {
        return _vm.submitAddMember();
      },
      "cancel": function cancel($event) {
        _vm.selectedStaff = null;
      }
    }
  }, [_c('vue-typeahead-bootstrap', {
    attrs: {
      "data": _vm.staffSuggestions,
      "size": "md",
      "placeholder": "請輸入姓名或員工編號",
      "autoClose": false,
      "serializer": function serializer(s) {
        return s.name;
      },
      "disabledValues": ['搜尋中...'],
      "showAllResults": true,
      "min-matching-chars": 1
    },
    on: {
      "input": _vm.lookupStaff,
      "hit": _vm.handleSelected
    },
    scopedSlots: _vm._u([{
      key: "suggestion",
      fn: function fn(_ref) {
        var data = _ref.data;
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-avatar', {
          staticClass: "mr-2",
          attrs: {
            "src": data.avatar_url
          }
        }), _c('div', {
          staticClass: "\n              mr-auto\n              font-weight-bold\n              text-nowrap text-truncate\n            "
        }, [_vm._v(" " + _vm._s(data.name)), _c('br'), _c('span', {
          staticClass: "staff-list-info"
        }, [_vm._v(" " + _vm._s(_vm.displayStaffInfo(data)) + " ")])])], 1)];
      }
    }]),
    model: {
      value: _vm.staffKeyword,
      callback: function callback($$v) {
        _vm.staffKeyword = $$v;
      },
      expression: "staffKeyword"
    }
  }), _vm.selectedStaff ? _c('div', {
    staticClass: "d-flex align-items-center py-3"
  }, [_c('b-avatar', {
    staticClass: "mr-2",
    attrs: {
      "src": _vm.selectedStaff.avatar_url
    }
  }), _c('div', {
    staticClass: "\n          mr-auto\n          font-weight-bold\n          text-nowrap text-truncate\n          flex-fill\n        "
  }, [_vm._v(" " + _vm._s(_vm.selectedStaff.name)), _c('br'), _c('span', {
    staticClass: "staff-list-info"
  }, [_vm._v(" " + _vm._s(_vm.displayStaffInfo(_vm.selectedStaff)) + " ")])]), _c('b-button', {
    staticClass: "p-1 mr-2",
    attrs: {
      "size": "xs",
      "pill": "",
      "variant": "danger"
    },
    on: {
      "click": function click($event) {
        _vm.selectedStaff = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times m-0"
  })])], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }